import {
  Container,
  FieldButtonContainer,
  Input,
  Text,
  Title,
} from './ReportField.styles';
import { useEffect, useState } from 'react';
import { Cross, MiniButton } from 'src/components/atomsLegacy';

interface Props {
  title: string;
  value: string;
  hidden: boolean;
  'data-testid'?: string;
  editable?: boolean;
  onSave?: (value: string) => void;
  onEditClick?: () => void;
  hiddenString?: string;
}

export const ReportField = ({
  title,
  value,
  hidden,
  editable,
  hiddenString = '**********',
  onSave,
  onEditClick,
  ...props
}: Props) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState('');
  useEffect(() => {
    if (isEditing) {
      setTempValue(value);
    }
  }, [isEditing, value]);
  return (
    <Container data-testid={props['data-testid']}>
      <Title>{title}</Title>
      {editable && (
        <FieldButtonContainer>
          {isEditing ? (
            <>
              <Input
                value={tempValue}
                onChange={(event) => setTempValue(event.target.value)}
              />
              <FieldButtonContainer>
                <MiniButton
                  onClick={() => {
                    onSave?.(tempValue);
                    setIsEditing(false);
                  }}
                  editing={true}
                  data-testid={`${props['data-testid']}-save`}
                  text="SAVE"
                />
                <Cross
                  width="8px"
                  height="8px"
                  onClick={() => setIsEditing(false)}
                  data-testid={`${props['data-testid']}-cancel`}
                />
              </FieldButtonContainer>
            </>
          ) : (
            <>
              <Text weight="regular">{hidden ? hiddenString : value}</Text>
              <MiniButton
                onClick={() =>
                  onEditClick ? onEditClick() : setIsEditing(true)
                }
                data-testid={`${props['data-testid']}-edit`}
                text="EDIT"
                editing={false}
              />
            </>
          )}
        </FieldButtonContainer>
      )}
      {!editable && (
        <Text weight="regular">{hidden ? hiddenString : value}</Text>
      )}
    </Container>
  );
};
